import { render, staticRenderFns } from "./DWTFormGeneratorDesktop.vue?vue&type=template&id=51acf413&scoped=true"
import script from "./DWTFormGeneratorDesktop.vue?vue&type=script&lang=js"
export * from "./DWTFormGeneratorDesktop.vue?vue&type=script&lang=js"
import style0 from "./DWTFormGeneratorDesktop.vue?vue&type=style&index=0&id=51acf413&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51acf413",
  null
  
)

export default component.exports